const API_BASE_URL = "http://localhost:8000";

const handleStreaming = (response, resolve, { stream, callback }) => {
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    let combinedResult = [];

    function processChunk({ done, value }) {
        if (done) {
            // Handle any remaining buffered data
            if (buffer.trim()) {
                try {
                    const payload = JSON.parse(buffer);
                    combinedResult.push(payload);
                    if (stream) {
                        console.assert(callback);
                        callback(payload);
                    }
                } catch (error) {
                    console.error("Error parsing final JSON:", error);
                }
            }
            resolve(combinedResult.reduce((acc, data) => acc + data.chunk, ""));
            return;
        }

        buffer += decoder.decode(value, { stream: true });

        let lastNewlineIndex = buffer.lastIndexOf("\n");
        if (lastNewlineIndex !== -1) {
            const completeMessages = buffer.slice(0, lastNewlineIndex).split("\n");
            buffer = buffer.slice(lastNewlineIndex + 1); // Keep the remaining data in the buffer

            for (const message of completeMessages) {
                if (message.trim()) {
                    try {
                        const payload = JSON.parse(message);
                        combinedResult.push(payload);
                        if (stream) {
                            console.assert(callback);
                            callback(payload);
                        }
                    } catch (error) {
                        console.error("Error parsing JSON:", error);
                    }
                }
            }
        }

        return reader.read().then(processChunk);
    }

    return reader.read().then(processChunk);
};

export const getIntro = ({ stream, callback }) => {
    console.debug("getIntro");
    return new Promise((resolve, reject) => {
        fetch(`${API_BASE_URL}/intro`, {
            method: "GET",
        })
            .then((response) => handleStreaming(response, resolve, { stream, callback }))
            .catch((error) => {
                console.log("Error: ", error);
                // reject(new Error(`Error: ${error.message}`))
            });
    });
};

export const postChat = (prompt, { stream, callback }) => {
    console.debug("postChat");
    const fallbackMessage =
        "Jeremy is popular this week, I've run out of API credits, please scroll down to see his resume.";
    return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
            resolve(fallbackMessage);
        }, 1500);
        fetch(`${API_BASE_URL}/chat`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                prompt: prompt,
            }),
        })
            .then((response) => {
                clearTimeout(timeout);
                handleStreaming(response, resolve, { stream, callback });
            })
            .catch((error) => {
                console.log("Error: ", error);
            });
    });
};
